import { MonitorHeart } from '@mui/icons-material'
import * as React from 'react'
import {
  Box,
  IconButton,
  Tooltip
} from '@mui/material'
import { useTranslation } from 'react-i18next'

const SystemMonitorIcon = React.forwardRef((props, ref) => {
  const { t } = useTranslation()

  const handleClick = () => {
    const monitorUrl = process.env.MONITOR_URL || 'http://172.16.113.73:52345/infrastructure'
    window.open(monitorUrl, '_blank')
  }

  return (
    <Box>
      <Tooltip title={t('System Monitor')} placement="top-start">
        <IconButton onClick={handleClick}>
          <MonitorHeart />
        </IconButton>
      </Tooltip>
    </Box>
  )
})

SystemMonitorIcon.displayName = 'SystemMonitorIcon'

export default SystemMonitorIcon